import { Injectable } from "@angular/core";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ExpenseListService {
  constructor(
    private postService: PostService,
    private helper: HelperService
  ) {}

  getExpenses(parameters: any): Observable<any> {
    const formData = new FormData();

    if (
      parameters.hasOwnProperty("event_level") &&
      parameters.event_level == "country"
    ) {
      formData.append(this.helper.getMangledName("API_getExpense"), "1");
      formData.append("event_id", parameters.event_id);
      formData.append("place_id", parameters.country_id);
      formData.append("subgroup_id", "1");
    } else {
      formData.append("API_getExpense", "1");
      formData.append("event_id", parameters.event_id);
      formData.append("place_id", parameters.const_id);
      formData.append("subgroup_id", "5");
    }

    return this.postService.post(this.helper.getAPIUrl(), formData);
  }

  getExpenseTypes(parameters: any): Observable<any> {
    const formData = new FormData();
    formData.append(this.helper.getMangledName("API_getExpenseTypes"), "1");
    return this.postService.post(this.helper.getAPIUrl(), formData);
  }
}
